/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type { BankProductResponse, FindProductsParams } from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const findProducts = (
  params?: FindProductsParams,
  signal?: AbortSignal
) => {
  return customInstance<BankProductResponse[]>({
    url: `/operations/products/search`,
    method: 'GET',
    params,
    signal,
  });
};

export const getFindProductsQueryKey = (params?: FindProductsParams) => {
  return [`/operations/products/search`, ...(params ? [params] : [])] as const;
};

export const getFindProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof findProducts>>,
  TError = unknown
>(
  params?: FindProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findProducts>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findProducts>>> = ({
    signal,
  }) => findProducts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof findProducts>>
>;
export type FindProductsQueryError = unknown;

export const useFindProducts = <
  TData = Awaited<ReturnType<typeof findProducts>>,
  TError = unknown
>(
  params?: FindProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findProducts>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindProductsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
